export default __webpack_public_path__ + "static/media/delwyn-joseph.41e1873a.jpg";